import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { cn } from './ui/utils';
const faqs = [{
  q: '¿Cuánto tiempo al día necesito?',
  a: 'Solo 15 minutos de enfoque total.'
}, {
  q: '¿Es seguro?',
  a: 'Sí, son movimientos suaves basados en principios somáticos básicos.'
}, {
  q: '¿Recibiré algo físico?',
  a: 'No, es un producto digital de acceso inmediato para que empieces hoy mismo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-zinc-900/30 border-t border-zinc-800/50" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <FadeIn data-id="element-27">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12" data-id="element-28">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <FadeIn key={i} delay={0.1 * i} data-id="element-30">
                <div className="glass-panel rounded-2xl overflow-hidden" data-id="element-31">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50" aria-expanded={isOpen} data-id="element-32">
                    <span className="text-lg font-medium text-zinc-200" data-id="element-33">
                      {faq.q}
                    </span>
                    <ChevronDown className={cn('w-5 h-5 text-zinc-500 transition-transform duration-300', isOpen && 'transform rotate-180')} data-id="element-34" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-35">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-36">
                        <div className="px-6 pb-5 text-zinc-400" data-id="element-37">{faq.a}</div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}